import react from "react";


export function buildEmailData({ invoice, account, practice }) {
    const practiceNumber =
      practice?.practiceNumber || invoice?.practice?.practiceNumber || "";

    // Address the ACCOUNT HOLDER on outgoing invoice/receipt/credit-note
    // emails — they are the bill payer and recipient. The patient is who
    // the service was for and may be a minor or dependent. Fall back to
    // the patient name only if the account fields are empty (defensive).
    const patientFirstName =
      account?.accountFullNames || invoice?.patient?.patientFirstName || "";
    const patientLastName =
      account?.accountLastName || invoice?.patient?.patientLastName || "";

    return {
      // used to select finComms template
      practiceNumbers: practiceNumber ? [String(practiceNumber)] : [],

      // practice info
      practiceName:
        practice?.practiceName || invoice?.practice?.practiceName || "",
      practiceEmail:
        practice?.practiceEmail || invoice?.practice?.practiceEmail || "",
      practicePhone:
        practice?.practicePhoneNumber ||
        invoice?.practice?.practicePhoneNumber ||
        "",
      practiceNumber,
      logoURL: practice?.logoURL || invoice?.practice?.logoURL || "",

      // patient
      patientFirstName,
      patientLastName,
      patientName: [patientFirstName, patientLastName]
        .filter(Boolean)
        .join(" "),

      // invoice vars
      invoiceNumber: invoice?.invoiceNumber || "",
      invoiceDate:
        invoice?.invoiceDate ||
        invoice?.invoiceCreatedDate?.slice?.(0, 10) ||
        "",

      // receipt (present in your sample; backend will ignore if type !== "receipt")
      receiptNumber: invoice?.receiptNumber || "",
      receiptDate: invoice?.receiptDate || invoice?.invoiceDate || "",

      // credit note (add if you have them later)
      creditNoteNumber: invoice?.creditNoteNumber || "",
      creditNoteDate: invoice?.creditNoteDate || "",

      // unique appointment IDs from invoice lines
      appointmentIds: [
        ...new Set(
          (invoice?.lines || [])
            .map((line) => line.appointmentId)
            .filter(Boolean)
        ),
      ],
    };
  }

  